<template>
  <div class="hidden" />
</template>

<script setup lang="ts">
import { forceReload } from "@/utils/cacheBuster";
import { APP_VERSION } from "@/version";
import { onMounted, onUnmounted } from "@vue/runtime-core";

let updateCheckInterval: number | null = null;

// Vérifie si l'heure actuelle est >= 18h
const isAfter18h = (): boolean => {
  return new Date().getHours() >= 18;
};

// Vérifie si une nouvelle version est disponible et recharge silencieusement
const checkForUpdates = async () => {
  try {
    // Vérifie si le service worker a une mise à jour
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        registration.addEventListener("updatefound", () => {
          if (isAfter18h()) {
            silentReload();
          } else {
            localStorage.setItem("pending-update", "true");
          }
        });
      }
    }

    // Vérifie en comparant avec la version stockée
    const currentVersion = localStorage.getItem("app-version") || "1.0.0";
    const newVersion = APP_VERSION || "1.0.0";

    if (currentVersion !== newVersion) {
      if (isAfter18h()) {
        silentReload();
      } else {
        localStorage.setItem("pending-update", "true");
      }
      return;
    }

    // Si une mise à jour était en attente et qu'on est après 18h, recharger
    if (localStorage.getItem("pending-update") === "true" && isAfter18h()) {
      silentReload();
    }
  } catch (error) {
    console.error("Erreur lors de la vérification des mises à jour:", error);
  }
};

const silentReload = () => {
  localStorage.setItem("app-version", APP_VERSION || "1.0.0");
  localStorage.removeItem("pending-update");
  forceReload();
};

onMounted(() => {
  // Vérifie les mises à jour toutes les 5 minutes
  updateCheckInterval = window.setInterval(checkForUpdates, 5 * 60 * 1000);

  // Vérification initiale
  checkForUpdates();
});

onUnmounted(() => {
  if (updateCheckInterval) {
    clearInterval(updateCheckInterval);
  }
});
</script>
